export default function IRSparkline({data, color="#e8c875", height=64}) {
  if(!data?.length)return<div style={{height,background:"rgba(255,255,255,0.04)",borderRadius:8}}/>;
  const vals=data.map(d=>d.rate).filter(v=>v!=null);
  if(vals.length<2)return null;
  const W=200,H=height,mn=Math.min(...vals),mx=Math.max(...vals),rng=mx-mn||0.01;
  const pts=vals.map((v,i)=>({x:(i/(vals.length-1))*W,y:H-10-((v-mn)/rng)*(H*0.76)}));
  const path=pts.map((p,i)=>`${i===0?"M":"L"} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(" ");
  const area=path+` L ${pts[pts.length-1].x} ${H} L 0 ${H} Z`;
  const last=pts[pts.length-1];
  const uid=color.replace("#","");
  return(
    <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height,display:"block"}}>
      <defs>
        <linearGradient id={`irSg${uid}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity="0.4"/><stop offset="100%" stopColor={color} stopOpacity="0"/></linearGradient>
        <filter id={`irSf${uid}`} x="-10%" y="-80%" width="120%" height="260%"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
      </defs>
      <path d={area} fill={`url(#irSg${uid})`}/>
      <path d={path} fill="none" stroke={color} strokeWidth={5} opacity={0.28} filter={`url(#irSf${uid})`}/>
      <path d={path} fill="none" stroke={color} strokeWidth={2}/>
      <circle cx={last.x} cy={last.y} r={4} fill={color} stroke="#000" strokeWidth={1.5}/>
      <text x={3} y={H-2} fontSize={9} fill="rgba(255,255,255,0.35)">{data[0]?.date?.slice(0,7)}</text>
      <text x={W-3} y={H-2} textAnchor="end" fontSize={9} fill="rgba(255,255,255,0.35)">{data[data.length-1]?.date?.slice(0,7)}</text>
    </svg>
  );
}
